import * as _ from 'lodash-es';
import {selectCurrentAnnotationState, selectTranslatorsState} from '@store/app.states';
import {createSelector} from '@ngrx/store';

// Le plus 'haut' state...
export const getAllAnnotators = createSelector(
  selectTranslatorsState,
  selectCurrentAnnotationState,
  (state, annotationState) => {
    return {
      annotators: state?.annotators || [],
      selectedAnnotators: {
        ids: annotationState.selectedAnnotators?.ids || [],
        restrictions: annotationState?.selectedAnnotators?.restrictions,
      },
    };

  }
);

export interface IGetAnnotatorsContext {
  annotators: IAnnotatorUser[];
  selectedAnnotators: {
    ids: number[];
    restrictions: {
      [p: number]: {
        responseIds: number[] } } | undefined }
}

export interface IAnnotatorUser {
  id: number;
  email: string;
  firstname: string;
  lastname: string;
  password: string;
  media: number;
  notes: string;
  secretKey: string;
}

